import LocalizedStrings from 'localized-strings';

interface CreateNewBeneficiaryLocalizedType {
  bicIsForbidden: string;
  confirm: string;
  country: string;
  create: string;
  createAndSend: string;
  errorMessage: string;
  ibanNotMatchingCountry: string;
  label: string;
  myAccount: string;
  myAccountDescription: string;
  name: string;
  nonAllowedCharactersInName: string;
  sepaFaqButton: string;
  sepaInfoBox: string;
  smsDescription: string;
  smsTitle: string;
  successMessage: string;
  successTitle: string;
  swiftBic: string;
  swiftBicNotMatchingCountry: string;
  swiftBicNotValid: string;
  title: string;
  createOnly: string;
  queryBicLoading: string;
  queryBicError: string;
}

export default new LocalizedStrings<CreateNewBeneficiaryLocalizedType>({
  en: {
    bicIsForbidden:
      'This BIC is not accepted at the moment\nIf the IBAN belongs to Crédit Agricole, enter the BIC AGRIFRPP',
    confirm: 'Confirm',
    country: 'Country of beneficiary bank',
    create: 'Add this beneficiary',
    createAndSend: 'Add and make a transfer',
    createOnly: 'Add',
    errorMessage: 'An error occurred while creating the beneficiary',
    ibanNotMatchingCountry:
      'This IBAN does not correspond to the country indicated above.',
    label: 'Label (optional)',
    myAccount: 'This account is mine',
    myAccountDescription:
      'Your personal accounts will show at the top of your recipient list.',
    name: 'Beneficiary name',
    nonAllowedCharactersInName:
      'Accents and special characters are not allowed except / - ? : ( ) . +',
    queryBicError: 'BIC could not be retrieved, please enter it manually.',
    queryBicLoading: 'BIC recovery in progress…',
    sepaFaqButton: 'The country you are looking for is not in the list?',
    sepaInfoBox:
      'SWIFT transfers are only available for incoming transactions. Only SEPA zone beneficiaries can be added.',
    smsDescription:
      'For security reasons, this type of actions requires an additional verification.',
    smsTitle: 'Confirm with the code you received by SMS',
    successMessage:
      '**{beneficiaryName}** was successfully added to your beneficiary list. You can already make a transfer to your beneficiary.',
    successTitle: 'New beneficiary added',
    swiftBic: 'BIC',
    swiftBicNotMatchingCountry:
      'This BIC does not correspond to the country indicated above.',
    swiftBicNotValid:
      'This BIC seems incorrect. Could you please check and correct it? Please note that only BICs from the SEPA Area are accepted.',
    title: 'Add a beneficiary',
  },
  fr: {
    bicIsForbidden:
      'Ce BIC n’est pas accepté pour le moment.\nSi l’IBAN appartient au Crédit Agricole, saisissez le BIC AGRIFRPP',
    confirm: 'Confirmer',
    country: 'Pays de la banque bénéficiaire',
    create: 'Ajouter ce bénéficiaire',
    createAndSend: 'Ajouter et effectuer un virement',
    createOnly: 'Ajouter',
    errorMessage: 'Une erreur est survenue lors de la création du bénéficiaire',
    ibanNotMatchingCountry:
      'L’IBAN ne correspond pas au pays indiqué ci-dessus.',
    label: 'Libellé (facultatif)',
    myAccount: 'Ce compte m’appartient',
    myAccountDescription:
      'Vos comptes personnels apparaissent en tête de votre liste de bénéficiaires.',
    name: 'Nom du bénéficiaire',
    nonAllowedCharactersInName:
      'Les accents et les caractères spéciaux ne sont pas autorisés, exceptés / - ? : ( ) . +',
    queryBicError:
      'Le BIC n’a pas pu être récupéré, veuillez le renseigner manuellement.',
    queryBicLoading: 'Récupération du BIC en cours…',
    sepaFaqButton: "Le pays recherché n'est pas dans la liste ?",
    sepaInfoBox:
      'Les virements swift sont disponibles uniquement pour des transactions entrantes. Seul·es des bénéficiaires en zone SEPA peuvent être ajouté·es.',
    smsDescription:
      'Pour plus de sécurité, nous souhaitons nous assurer que vous êtes à l’origine de cette demande.',
    smsTitle: 'Confirmez avec le code reçu par SMS',
    successMessage:
      '**{beneficiaryName}** a bien été ajouté à votre liste de bénéficiaires. Vous pouvez dès maintenant lui faire un virement.',
    successTitle: 'Nouveau bénéficiaire ajouté',
    swiftBic: 'BIC',
    swiftBicNotMatchingCountry:
      'Le BIC ne correspond pas au pays indiqué ci-dessus.',
    swiftBicNotValid:
      'Le BIC saisi semble incorrect. Pourriez-vous le vérifier et le corriger ? Notez que seuls les BIC provenant de la zone SEPA sont acceptés.',
    title: 'Ajoutez un bénéficiaire',
  },
} as const);
